import Lottie from "react-lottie";
import styles from "./WhatsAppPopup.module.scss";
import WHATSAPP_ANIMATION from "../../../public/assets/lotties/WhatsAppLottie.json";

const WhatsAppPopup = () => {
  const whatsappURL = `https://api.whatsapp.com/send/?phone=919669768769&text=Hi%2C+Pl+Connect+me+with+Top+Astrologer&type=phone_number&app_absent=0
`;

  return (
    <div className={styles.whatsapp_popup_container}>
      {/* for mobile */}
      <div
        className={styles.pc_version}
        onClick={() => window.open(whatsappURL, "_blank")}
      >
        {/* @ts-expect-error Server Component */}
        <Lottie
          width={50}
          height={50}
          options={{ animationData: WHATSAPP_ANIMATION }}
          isClickToPauseDisabled={true}
        />

        <div className={styles.text_section}>
          <span>Chat Now on </span>
          <span> WhatsApp</span>
        </div>
      </div>

      {/* for pc */}
      <div className={styles.mobile_version}>
        <div className={styles.whats_app_bar}>
          <div className={styles.content_section}>
            <div className={styles.text_section}>
              Connect with Top Astrologers on Whatsapp
            </div>

            <div
              className={styles.chat_btn}
              onClick={() => window.open(whatsappURL, "_blank")}
            >
              {/* @ts-expect-error Server Component */}
              <Lottie
                width={50}
                height={50}
                options={{ animationData: WHATSAPP_ANIMATION }}
                isClickToPauseDisabled={true}
              />
              Chat now
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppPopup;
